export const menuTitle = { title: "UNIVERCITY", label: "Univercity" }
  